<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>

		</thead>

		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow" [ngClass]="{'text-danger': item.is_enabled === 0}">
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_enabled === 1" [icon]="['fas', 'power-off']" size="sm" class="text-success"
						ngbTooltip="Enabled - Available for download" placement="end"></fa-icon>
					<fa-icon *ngIf="item.is_enabled === 0" [icon]="['fas', 'ban']" size="sm" class="text-danger"
						ngbTooltip="Disabled - Not available for download" placement="end"></fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="!!item.link && item.link !== ''" [icon]="['fas', 'external-link-square-alt']" size="sm"
						class="text-success" ngbTooltip="Has link" placement="end"></fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.file_id !== 0" [icon]="['fas', 'book']" size="sm" class="text-success" ngbTooltip="Has a file"
						placement="end"></fa-icon>
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="item.is_private === 1" [icon]="['fas', 'lock']" size="sm" class="text-warning"
						ngbTooltip="Private - Limited Access" placement="end"></fa-icon>
					<fa-icon *ngIf="item.is_private === 0" [icon]="['fas', 'globe']" size="sm" class="text-success"
						ngbTooltip="Public - Generally Available" placement="end"></fa-icon>
				</td>

				<td *ngIf="showProduct" class="cp-chopped-col-medium">{{ item.prod_name }}</td>
				<td class="cp-chopped-col-long">
					<a [routerLink]="['/' + ac.urls.documents, item.id]">
						{{ item.label }}
					</a>
				</td>
				<td class="text-center">{{ item.org_ids.length }}</td>
				<td class="text-center">{{ item.group_ids.length }}</td>
				<td class="text-center">{{ item.package_ids.length }}</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.added_on" [ngbTooltip]="item.added_on | date: ac.shortPageDateTimeFmt">
						{{ item.added_on | timeback }}
					</div>
				</td>
				<td class="text-center text-nowrap">
					<div *ngIf="item.last_download" [ngbTooltip]="item.last_download | date: ac.shortPageDateTimeFmt">
						{{ item.last_download | timeback }}
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>